import { Link, NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, FolderOpen, ShoppingBag, Factory, MessagesSquare, HelpCircle, Settings, LogOut, Bell, Ticket, Images, ImagePlus, Boxes } from "lucide-react";

const nav = [
  { to: "/admin", label: "DASHBOARD", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "PRODUCTS", icon: Package },
  { to: "/admin/import", label: "IMPORT CSV", icon: Package },
  { to: "/admin/images/bulk", label: "BULK IMAGES", icon: ImagePlus },
  { to: "/admin/images/unassigned", label: "UNASSIGNED IMAGES", icon: Images },
  { to: "/admin/inventory", label: "INVENTORY", icon: Boxes },
  { to: "/admin/categories", label: "CATEGORIES", icon: FolderOpen },
  { to: "/admin/orders", label: "ORDERS", icon: ShoppingBag },
  { to: "/admin/production", label: "PRODUCTION", icon: Factory },
  { to: "/admin/waitlist", label: "WAITLIST", icon: Bell },
  { to: "/admin/discounts", label: "DISCOUNTS", icon: Ticket },
  { to: "/admin/questions", label: "QUESTIONS", icon: MessagesSquare },
  { to: "/admin/faqs", label: "FAQ", icon: HelpCircle },
  { to: "/admin/settings", label: "SETTINGS", icon: Settings },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const token = localStorage.getItem("admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  const logout = () => { localStorage.removeItem("admin_token"); navigate("/admin/login"); };
  return (
    <div className="min-h-screen grid md:grid-cols-[240px,1fr] bg-[color:var(--bg)]">
      <aside className="border-r border-[color:var(--border)] p-6 md:sticky md:top-0 md:h-screen">
        <Link to="/" className="display text-3xl">FERAL<br/>RIOT</Link>
        <div className="text-[10px] tracking-widest text-neutral-500 mt-1">ADMIN CONSOLE</div>
        <nav className="mt-8 space-y-1">
          {nav.map((n) => (
            <NavLink key={n.to} end={n.end} to={n.to} data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2 text-xs tracking-widest ${isActive ? "bg-white text-black" : "text-neutral-400 hover:text-white"}`}>
              <n.icon size={14} strokeWidth={1.25} /> {n.label}
            </NavLink>
          ))}
          <button data-testid="admin-logout" onClick={logout} className="flex items-center gap-3 px-3 py-2 text-xs tracking-widest text-neutral-400 hover:text-[color:var(--accent)] w-full">
            <LogOut size={14} strokeWidth={1.25} /> LOGOUT
          </button>
        </nav>
      </aside>
      <main className="p-4 md:p-8 min-w-0"><Outlet /></main>
    </div>
  );
}
